import React, {useState, useEffect} from 'react';

import {ColorPicker, DayPicker} from 'components';
import {ActivityTypesSelect, PosterVariantSelect} from 'components/select';
import {FormInput, Label, TimeRange} from 'components/ultra';

import {SidebarSection} from './styles';

interface Settings {
  activitiesStartDate: string;
  activitiesEndDate: string;
  activityTypes: any;
  baseColor: string;
  highlightColor: string;
  name: string;
  variant: any;
}

interface Props {
  loading: boolean;
  settings: Settings;
  presets: any;
  onChange(settings: Settings): void;
}

export function SidebarControls(props: Props) {
  const [settings, setSettings] = useState(props.settings);
  const [didMount, setDidMount] = useState(false);

  useEffect(() => setDidMount(true), []); // could probably be replace by loading state later on
  useEffect(() => {
    if (didMount) {
      props.onChange(settings);
    }
  }, [settings]);

  return (
    <>
      <SidebarSection>
        <FormInput
          type="text"
          name="name"
          label="Name"
          defaultValue={settings.name}
          onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
            setSettings({...settings, name: event.target.value})
          }
        />
      </SidebarSection>
      <SidebarSection>
        <PosterVariantSelect
          options={props.presets.variants}
          value={settings.variant}
          onChange={variant => setSettings({...settings, variant})}
        />
      </SidebarSection>
      <SidebarSection>
        {settings.variant === 'DOT' ? (
          <TimeRange
            onChange={date => setSettings({...settings, ...date})}
            range={4}
            active={settings.activitiesEndDate}
          />
        ) : (
          <DayPicker
            from={settings.activitiesStartDate}
            to={settings.activitiesEndDate}
            onChange={date => setSettings({...settings, ...date})}
          />
        )}
      </SidebarSection>
      <SidebarSection>
        <ActivityTypesSelect
          options={props.presets.activityTypes}
          value={settings.activityTypes}
          onChange={activityTypes => setSettings({...settings, activityTypes})}
        />
      </SidebarSection>
      <SidebarSection>
        <Label>Background</Label>
        <ColorPicker
          color={settings.baseColor}
          colors={[
            '#000000',
            '#505050',
            '#656565',
            '#9CAFB1',
            '#cccccc',
            '#ffffff',
          ]}
          onChange={color => setSettings({...settings, baseColor: color.hex})}
        />
      </SidebarSection>
      <SidebarSection>
        <Label>Highlight</Label>
        <ColorPicker
          color={settings.highlightColor}
          colors={[...props.presets.colors, '#ffffff']}
          onChange={color =>
            setSettings({...settings, highlightColor: color.hex})
          }
        />
      </SidebarSection>
    </>
  );
}
